import { baseSchemaProperties } from '../base-schema-properties'
import { DEFAULT_COLOR_GRAY, DEFAULT_MARKDOWN_TEXT } from '../constants'

export default {
  $schema: 'http://json-schema.org/draft-07/schema#',
  title: 'Video',
  description: 'Video block with title and markdown description',
  type: 'object',
  required: ['sourse', 'link'],
  properties: {
    ...baseSchemaProperties,
    description: {
      title: 'Description',
      type: 'string',
      'ui:options': {
        placeholder: DEFAULT_MARKDOWN_TEXT,
        type: 'textarea',
        rows: 6,
      },
    },
    textColor: {
      title: 'Text Color',
      type: 'string',
      default: DEFAULT_COLOR_GRAY,
    },
    maxWidth: {
      title: 'Max width in pixels',
      type: 'number',
    },
    source: {
      title: 'Source',
      type: 'string',
      default: 'youtube',
      enum: ['youtube', 'gcore', 'googledrive'],
      enumNames: ['Youtube', 'G-Core', 'Google Drive'],
    },
    videoId: {
      title: 'Video id',
      type: 'string',
      default: 'vb8NvZkck5c',
    },
  },
}
